import gsap from 'gsap';

export default class AnnouncementBarItem extends HTMLElement {
  private scrollContent: HTMLDivElement | null = null;
  private inner: HTMLDivElement | null = null;
  private gradientLeft: HTMLDivElement | null = null;
  private gradientRight: HTMLDivElement | null = null;

  private leftGradientIsVisible = false;
  private rightGradientIsVisible = false;
  private isOverflowing = false;

  private onScrollBound = this.onScroll.bind(this);
  private onResizeBound = this.onResize.bind(this);

  connectedCallback(): void {
    this.scrollContent = this.querySelector('[data-announcement-bar-item-ref="scroll-content"]');
    this.inner = this.querySelector('[data-announcement-bar-item-ref="inner"]');
    this.gradientLeft = this.querySelector('[data-announcement-bar-item-ref="gradient-left"]');
    this.gradientRight = this.querySelector('[data-announcement-bar-item-ref="gradient-right"]');

    this.addEventListeners();
    this.update();
  }

  addEventListeners(): void {
    this.scrollContent?.addEventListener('scroll', this.onScrollBound, { passive: true });
    window.addEventListener('resize', this.onResizeBound);
  }

  removeEventListeners(): void {
    this.scrollContent?.removeEventListener('scroll', this.onScrollBound);
    window.removeEventListener('resize', this.onResizeBound);
  }

  onScroll(): void {
    this.updateGradients();
  }

  onResize(): void {
    this.update();
  }

  update(): void {
    this.updateAlignment();
    this.updateGradients();
  }

  updateAlignment(): void {
    if (!this.scrollContent || !this.inner) return;

    const isOverflowing = this.scrollContent.scrollWidth > this.scrollContent.clientWidth + 1;

    if (isOverflowing === this.isOverflowing) return;

    this.isOverflowing = isOverflowing;
    this.inner.classList.toggle('justify-center', !isOverflowing);
    this.inner.classList.toggle('justify-start', isOverflowing);
  }

  updateGradients(): void {
    if (!this.scrollContent || !this.gradientLeft || !this.gradientRight) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.scrollContent;
    const shouldShowLeft = scrollLeft > 0;
    const shouldShowRight = scrollLeft < scrollWidth - clientWidth - 1;

    if (shouldShowLeft !== this.leftGradientIsVisible) {
      this.leftGradientIsVisible = shouldShowLeft;
      gsap.to(this.gradientLeft, {
        autoAlpha: shouldShowLeft ? 1 : 0,
        duration: 0.3,
        ease: 'power2.out',
      });
    }

    if (shouldShowRight !== this.rightGradientIsVisible) {
      this.rightGradientIsVisible = shouldShowRight;
      gsap.to(this.gradientRight, {
        autoAlpha: shouldShowRight ? 1 : 0,
        duration: 0.3,
        ease: 'power2.out',
      });
    }
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }
}

customElements.define('announcement-bar-item', AnnouncementBarItem);
